"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

var _animated_height = _interopRequireDefault(require("./shared/animated_height"));

require("../css/panel.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Panel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Panel, _React$Component);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Panel).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleVisibility", function (event) {
      event.preventDefault();

      _this.setState(function (state) {
        return {
          collapsed: !state.collapsed
        };
      });
    });

    _this.state = {
      collapsed: props.collapsed
    };
    return _this;
  }

  _createClass(Panel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          className = _this$props.className,
          collapsible = _this$props.collapsible,
          propsCollapsed = _this$props.collapsed,
          contentClassName = _this$props.contentClassName,
          hoverable = _this$props.hoverable,
          shadow = _this$props.shadow,
          children = _this$props.children,
          others = _objectWithoutProperties(_this$props, ["title", "className", "collapsible", "collapsed", "contentClassName", "hoverable", "shadow", "children"]);

      var collapsed = this.state.collapsed;
      var header;

      if (typeof title !== 'undefined' || collapsible) {
        var headerClasses = {
          'vn-panel__header': true
        };

        if (collapsible) {
          var iconClasses = (0, _classnames.default)({
            'vn-panel__toggle-icon': true,
            'vn-panel__toggle-icon--collapsed': collapsed
          });
          headerClasses['vn-panel__collapsible-header'] = true;
          headerClasses['vn-panel__collapsible-header--collapsed'] = collapsed;
          header = _react.default.createElement("button", {
            className: (0, _classnames.default)(headerClasses),
            onClick: this.handleVisibility,
            type: "button"
          }, _react.default.createElement("div", {
            className: "vn-panel__title"
          }, title, _react.default.createElement(_icon.default, {
            className: iconClasses,
            name: "chevron",
            color: "neutral-higher"
          })));
        } else {
          header = _react.default.createElement("div", {
            className: (0, _classnames.default)(headerClasses)
          }, _react.default.createElement("div", {
            className: "vn-panel__title"
          }, title));
        }
      }

      var contentClasses = _defineProperty({
        'vn-panel__content': true
      }, contentClassName, contentClassName !== undefined);

      var panelClasses = _defineProperty({
        'vn-panel': true,
        'vn-panel--shadow': shadow,
        'vn-panel__hoverable': hoverable === true
      }, className, className !== undefined);

      var content = _react.default.createElement("div", {
        className: (0, _classnames.default)(contentClasses)
      }, children);

      return _react.default.createElement("div", _extends({}, others, {
        className: (0, _classnames.default)(panelClasses)
      }), header, collapsible && _react.default.createElement(_animated_height.default, {
        in: !collapsed
      }, content), !collapsible && content);
    }
  }]);

  return Panel;
}(_react.default.Component);

Panel.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  collapsible: _propTypes.default.bool,
  collapsed: _propTypes.default.bool,
  contentClassName: _propTypes.default.string,
  hoverable: _propTypes.default.bool,
  shadow: _propTypes.default.bool,
  title: _propTypes.default.string
};
Panel.defaultProps = {
  className: undefined,
  collapsible: false,
  collapsed: false,
  contentClassName: undefined,
  hoverable: false,
  shadow: false,
  title: undefined
};
Panel.displayName = 'Panel';
var _default = Panel;
exports.default = _default;